export const CUSTOMIZED = [
    {
      item: 'Amulets',
      itemDescription: 'We created customizable amulet storage such as handcrafted amulet displays that reflect the unique identity of a brand ...',
      itemImageDesktop: '/images/packaging/customizedPorject/customizedPorject/desktop/amulets.webp',
      //itemImageMobile: '/images/packaging/customizedPorject/customizedPorject/mobile/amulets.webp',
      path: '/packaging/customized-projects/amulets',
    },
    {
      item: 'Automotive',
      itemDescription: 'Our expertise extends across diverse sectors, and we have left an indelible mark in the automotive industry ...',
      itemImageDesktop: '/images/packaging/customizedPorject/customizedPorject/desktop/automotive.webp',
      //itemImageMobile: '/images/packaging/customizedPorject/customizedPorject/mobile/automotive.webp',
      path: '/packaging/customized-projects/automotive',
    },
    {
      item: 'Coin',
      itemDescription: 'We offer the highest quality coin packaging solutions to protect and showcase your prized possessions ...',
      itemImageDesktop: '/images/packaging/customizedPorject/customizedPorject/desktop/coin.webp',
      //itemImageMobile: '/images/packaging/customizedPorject/customizedPorject/mobile/coin.webp',
      path: '/packaging/customized-projects/coin',
    },
    {
      item: 'Wine and Spirits',
      itemDescription: 'Our Wine and Spirits boxes encapsulate the essence of opulence, ensuring that each bottle is cradled in elegance and distinction ...',
      itemImageDesktop: '/images/packaging/customizedPorject/customizedPorject/desktop/wineAndSpirits.webp',
      //itemImageMobile: '/images/packaging/customizedPorject/customizedPorject/mobile/wineAndSpirits.webp',
      path: '/packaging/customized-projects/wine-and-spirits',
    },
    {
      item: 'Fashion',
      itemDescription: 'Our fashion packaging reflects the essence of your brand, captivating the senses and leaving a lasting mark ...',
      itemImageDesktop: '/images/packaging/customizedPorject/customizedPorject/desktop/fashion.webp',
      //itemImageMobile: '/images/packaging/customizedPorject/customizedPorject/mobile/fashion.webp',
      path: '/packaging/customized-projects/fashion',
    },
    {
      item: 'Gold',
      itemDescription: 'We believe that gold is valuable assets that deserve to be stored and displayed in a way that reflects their worth ...',
      itemImageDesktop: '/images/packaging/customizedPorject/customizedPorject/desktop/gold.webp',
      //itemImageMobile: '/images/packaging/customizedPorject/customizedPorject/mobile/gold.webp',
      path: '/packaging/customized-projects/gold',
    },
    {
      item: 'Jewels',
      itemDescription: 'To fulfill your unique brand and jewelry pieces, we arrange multiple options that support every aspect of your jewelry ...',
      itemImageDesktop: '/images/packaging/customizedPorject/customizedPorject/desktop/jewels.webp',
      //itemImageMobile: '/images/packaging/customizedPorject/customizedPorject/mobile/jewels.webp',
      path: '/packaging/customized-projects/jewels',
    },
    {
      item: 'Cosmetic',
      itemDescription: 'The cosmetic sector is also another field that we have been delivering a piece of art for ...',
      itemImageDesktop: '/images/packaging/customizedPorject/customizedPorject/desktop/cosmetic.webp',
      //itemImageMobile: '/images/packaging/customizedPorject/customizedPorject/mobile/cosmetic.webp',
      path: '/packaging/customized-projects/cosmetics',
    },
]